import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import sensechat_zh_CN from "./locale/sensechat/zh_CN.json";
import sensechat_zh_HK from "./locale/sensechat/zh_HK.json";
import sensechat_en from "./locale/sensechat/en.json";

import character_zh_CN from "./locale/character/zh_CN.json";
import character_zh_HK from "./locale/character/zh_HK.json";
import character_en from "./locale/character/en.json";

enum Lang {
  zh_CN = "zh_CN",
  zh_HK = "zh_HK",
  en = "en",
}

type Resources = {
  [key in Lang]: {
    translation: Record<string, string>;
  };
};

const i18nConfig: Record<"sensechat" | "character", Resources> = {
  sensechat: {
    zh_CN: {
      translation: sensechat_zh_CN,
    },
    zh_HK: {
      translation: sensechat_zh_HK,
    },
    en: {
      translation: sensechat_en,
    },
  },
  character: {
    zh_CN: {
      translation: character_zh_CN,
    },
    zh_HK: {
      translation: character_zh_HK,
    },
    en: {
      translation: character_en,
    },
  },
};

console.log("APP_NAME", APP_NAME);

const resources: Resources = i18nConfig[APP_NAME];
// const resources: Resources = i18nConfig.sensechat;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    interpolation: {
      format: function (value: string, format?: string) {
        if (format && format.startsWith("default(") && !value) {
          return format.slice(8, -1);
        }
        return value;
      },
    },
  });

const currentLang = LANGUAGE || "zh_HK";
i18n.changeLanguage(currentLang);

export default i18n;
